import { isString } from './types'

class FUIError extends Error {
  constructor(m: string) {
    super(m)
    this.name = 'FUIError'
  }
}

export function throwError(scope: string, m: string): never {
  throw new FUIError(`[${scope}] ${m}`)
}

export function debugWarn(err: Error): void
export function debugWarn(scope: string, message: string): void
export function debugWarn(scope: string | Error, message?: string): void {
  if (process.env.NODE_ENV !== 'production') {
    const error: Error = isString(scope) ? new FUIError(`[${scope}] ${message}`) : (scope as Error)
    console.warn(error)
  }
}
